// Adult party-game confessions and opinions, not graphic descriptions.
// Every card refers to adults and consensual experiences. No actions are required.
export const adultPacks = {
  'new friends': [
    "you have faked an orgasm and then accepted a compliment on the performance.",
    "the other player has a sex toy they would panic about airport security finding.",
    "you have had a one-night stand without learning the person's last name.",
    "the other player has paid for porn and would deny the charge was theirs.",
    "you have received a nude while sitting beside someone who absolutely could not see it.",
    "the other player has a kink that does not match their daytime personality.",
    "you have slept with an ex and immediately remembered why they were an ex.",
    "the other player has rehearsed dirty talk and still botched the delivery.",
    "you have left something at a hookup's place and decided it was dead to you.",
    "the other player has been someone's secret friends-with-benefits arrangement.",
    "you have interrupted your own sexting to look up how to spell something.",
    "the other player has a subscription they would hide before handing over their phone.",
    "you have pretended a sex-related purchase was a gift.",
    "the other player would admit to a foot fetish sooner than a terrible porn search.",
    "you have had sex with someone you would never introduce to your friends.",
    "the other player has accidentally played porn audio through the wrong speaker.",
    "you have bought condoms and added random groceries to make it look casual.",
    "the other player has exaggerated their sexual experience to seem less nervous.",
    "you have had a hookup that was better before either of you took your clothes off.",
    "the other player has a nickname in bed that would ruin their reputation at brunch.",
    "you have stayed in a situationship because the sex was doing all the work.",
    "the other player has researched a kink after pretending they already knew what it was.",
    "you have asked a friend whether a sex-related injury sounded believable.",
    "the other player would rather reveal their porn history than their nude selfie attempts.",
    "you have taken a nude, inspected the background, and cleaned your room.",
    "the other player has kept a hookup's contact under a fake name.",
    "you have had sex that was not worth losing sleep over.",
    "the other player has an unused sex toy with an ambitious origin story.",
    "you have Googled a noise your body made during sex.",
    "the other player has been caught by a delivery arriving during a hookup.",
    "you have sent a sext that read much better in your head.",
    "the other player has cancelled a booty call after discovering how far away it was.",
    "you have had to explain an adult purchase appearing in a shared shopping account.",
    "the other player has mistaken an invitation to sleep over for an invitation to have sex.",
    "you have showered at a hookup's place and used a product you could not identify.",
    "the other player would need more than one drawer for their adult accessories.",
    "you have had great sexting followed by deeply disappointing sex.",
    "the other player has silently graded a hookup's sexual confidence against their actual skill.",
    "you have packed underwear specifically for someone else to see and never shown them.",
    "the other player has had to say 'that is not my kink' with a straight face."
  ],
  'old friends': [
    "the other player has a sex story this group has heard in three different versions.",
    "you know which friend has faked an orgasm to end a disappointing hookup.",
    "the other player has slept with someone they publicly called unattractive.",
    "you have had to retrieve a friend from a hookup without asking questions.",
    "the other player has given a hookup a name based entirely on one bedroom incident.",
    "you know a friend's sex-toy preferences better than their middle name.",
    "the other player has tried to turn a booty call into a plus-one invitation.",
    "you have recognized two friends were sleeping together from how hard they denied it.",
    "the other player has a porn preference the group would guess completely wrong.",
    "you have helped a friend decide whether a sext was sexy or medically concerning.",
    "the other player has spent more on lingerie for a fling than gifts for close friends.",
    "you have had a friend request a post-hookup debrief before you even got home.",
    "the other player has called someone 'marriage material' after exactly one good night of sex.",
    "you could name the friend most likely to lose a sex toy during a move.",
    "the other player has described mediocre sex as amazing because they wanted the relationship to work.",
    "you have been asked to identify whether something in a friend's photo was a sex toy.",
    "the other player has a friends-with-benefits arrangement they think nobody has noticed.",
    "you have listened to a friend's bedroom complaint and privately sided with their partner.",
    "the other player has gone back to an ex for sex and called it closure.",
    "you could guess which friend has the most expensive adult subscription.",
    "the other player has blamed a sex-related mark on an implausible household accident.",
    "you have said 'I don't need that detail' during a friend's hookup story.",
    "the other player has bragged about sexual stamina without anyone asking.",
    "you could identify this friend's latest hookup from a single cryptic morning-after text.",
    "the other player has pretended to be sexually adventurous to impress someone.",
    "you have helped a friend hide an adult purchase before their family visited.",
    "the other player has changed their definition of 'just sex' after catching feelings.",
    "you have been on a group trip where a sex toy became a packing-list discussion.",
    "the other player has a kink the group discovered through an accidental joke.",
    "you know someone who has ranked exes by sex and claimed it was scientific.",
    "the other player has scheduled a hookup around the group dinner reservation.",
    "you have heard a friend's sex story and immediately questioned the physics.",
    "the other player has sent the group a 'never sleeping with them again' message more than once.",
    "you could spot when this friend is defending bad behavior because the sex is good.",
    "the other player has requested a wingperson for a purely sexual mission.",
    "you have been embarrassed by how loudly a friend shops for sex toys.",
    "the other player has claimed they were 'basically celibate' after two weeks without sex.",
    "you have correctly predicted which friends would eventually hook up.",
    "the other player has been more loyal to a booty call than to the group's plans.",
    "you know a bedroom nickname this friend hopes you have forgotten."
  ],
  'new couples': [
    "you have wondered whether the other player has a higher sex drive than you.",
    "the other player is more sexually adventurous than they have let on.",
    "you would admit owning a vibrator on an early date.",
    "the other player has a kink they are waiting to find the right moment to mention.",
    "you have had a sexual dealbreaker that only became obvious after sleeping together.",
    "the other player would rather talk frankly about masturbation than discuss their exes.",
    "you would be disappointed if a partner disliked dirty talk.",
    "the other player has considered going to a sex party but never admitted it on a date.",
    "you would try a blindfold with a consenting partner you trust.",
    "the other player has wondered whether your sexual confidence is real or good marketing.",
    "you would rather hear about a partner's kink upfront than months into dating.",
    "the other player has had a hookup they would still recommend despite never wanting to date them.",
    "you have worried about comparing badly with someone's previous sexual partner.",
    "the other player would rather initiate sex than wait for a subtle invitation.",
    "you would tell a new partner if you had not actually orgasmed.",
    "the other player has a sex toy they would want to introduce into a relationship.",
    "you have a stronger opinion about lights on during sex than you admit.",
    "the other player could enjoy consensual role-play without laughing out of character.",
    "you would consider sexual incompatibility a reason to end an otherwise good relationship.",
    "the other player prefers being told what someone wants in bed to being praised for guessing.",
    "you have regretted pretending to enjoy something sexual because it became a repeated request.",
    "the other player has a sexual preference they used to be embarrassed about.",
    "you would be comfortable discussing a past threesome without treating it as a confession.",
    "the other player would rather receive a requested nude than a cleverly worded sext.",
    "you have had a no-strings hookup that left you wanting strings.",
    "the other player would prefer a sexually inexperienced partner who listens over an expert who does not.",
    "you would rather be asked your boundaries than have someone assume you are into rough sex.",
    "the other player would be open to talking about consensual non-monogamy without promising to try it.",
    "you have turned down a second date because the first kiss made you doubt the sexual chemistry.",
    "the other player would find it awkward to tell you that their favorite sex toy works better.",
    "you would admit masturbating even if your partner wanted sex more often.",
    "the other player has a bedroom fantasy that is a conversation, not an automatic invitation.",
    "you have considered a threesome and immediately overthought the logistics.",
    "the other player would stop a hookup to say the sex was not working for them.",
    "you have a kink you would only disclose after trusting someone with your awkward side.",
    "the other player is more comfortable talking about porn than watching it with a partner.",
    "you would be annoyed if a partner treated every sleepover as guaranteed sex.",
    "the other player has been trying to tell whether you like taking the lead in bed.",
    "you would rather be remembered for good sex than smooth flirting.",
    "the other player has underwear that exists exclusively for hookups."
  ],
  'old couples': [
    "you have faked being asleep because explaining why you did not want sex felt exhausting.",
    "the other player knows which sex toy you would rescue first from a lost suitcase.",
    "you have agreed to a quickie and then complained it was too quick.",
    "the other player has a kink they still have not fully explained to you.",
    "you two have a sex position with an unflattering private nickname.",
    "the other player would correctly guess the last time you masturbated.",
    "you have put a sex date in the calendar under an aggressively boring title.",
    "the other player can tell when you are faking enthusiasm for a bedroom suggestion.",
    "you two have stopped during sex to deal with a completely ridiculous household problem.",
    "the other player would know which porn category would make you most defensive.",
    "you have used 'we have clean sheets' as a serious argument against sex.",
    "the other player has a sexual request you keep saying you will discuss later.",
    "you have quietly changed out of sexy underwear because comfort won the negotiation.",
    "the other player would rather upgrade the sex-toy drawer than upgrade the television.",
    "you two have attempted role-play and immediately recognized each other's work voice.",
    "the other player knows when you want an orgasm and when you mostly want attention.",
    "you have promised vacation sex with more confidence than your actual energy justified.",
    "the other player would enjoy an honest rating of what still works in your sex life.",
    "you two have had an argument about sex that was really about feeling unwanted.",
    "the other player would know which of your bedroom habits started with a previous partner.",
    "you have been irritated by how quickly your partner fell asleep after sex.",
    "the other player has a higher opinion of their dirty talk than you do.",
    "you two have forgotten where you hid something from the sex-toy drawer.",
    "the other player would enjoy taking turns choosing a mutually agreed bedroom experiment.",
    "you have suggested a hotel mainly because nobody would expect you to do laundry afterward.",
    "the other player could name a sexual boundary that has changed since you first got together.",
    "you two have tried to be quiet during sex and found yourselves laughing instead.",
    "the other player would be surprised by how often you masturbate.",
    "you have wanted less romance and a much more direct invitation to sex.",
    "the other player knows whether you prefer receiving praise or giving instructions in bed.",
    "you two have purchased an adult accessory with absolutely unrealistic expectations.",
    "the other player would be honest if a once-favorite sexual routine stopped working.",
    "you have had better sex after an awkward conversation than after an expensive date.",
    "the other player has initiated sex at a time that made you question their understanding of the schedule.",
    "you two have an unfinished conversation about a fantasy neither of you forgot.",
    "the other player would enjoy hearing a sext that did not sound like a household reminder.",
    "you have used the phrase 'not that drawer' with genuine urgency.",
    "the other player could name the most ridiculous thing that has interrupted your orgasm.",
    "you two could improve your sex life by admitting what you are bored of.",
    "the other player would rather hear 'I want sex' than decode your fifth hint."
  ],
  'hot takes': [
    "faking an orgasm creates a performance review nobody can learn from.",
    "the other player thinks a mediocre hookup can be worse than a good night alone with a sex toy.",
    "a friends-with-benefits arrangement needs an actual conversation about the benefits.",
    "the other player thinks paying for porn is less embarrassing than pretending nobody does.",
    "great sex is not a personality trait.",
    "the other player would count sexting someone else as cheating in an exclusive relationship.",
    "a threesome is a terrible emergency repair for a failing relationship.",
    "the other player thinks a toy in the bedroom is a teammate, not a rival.",
    "you can enjoy porn and still have unrealistic expectations about absolutely none of it.",
    "the other player thinks a one-night stand can deserve a five-star review and no sequel.",
    "having sex on a first date is less awkward than pretending you did not both want to.",
    "the other player would rather admit a fetish than pretend every kink is disgusting.",
    "having sex with an ex is not the same as getting closure from them.",
    "the other player thinks dirty talk is more likely to ruin the mood than rescue it.",
    "a nude request without prior interest is just unsolicited homework.",
    "the other player thinks sexual chemistry can hide a staggering amount of stupidity.",
    "being someone's best sex and worst relationship is a mixed review.",
    "the other player thinks a sex playlist should never include an advertisement.",
    "monogamy does not give someone ownership of their partner's masturbation habits.",
    "the other player would take a sexually generous beginner over a selfish expert.",
    "a hookup that requires a two-hour commute needs exceptional references.",
    "the other player thinks masturbation before a first date can improve your decision-making.",
    "you should not call yourself dominant if you cannot handle hearing no.",
    "the other player thinks a secret kink is less concerning than secret cheating.",
    "sexual bragging usually needs independent verification.",
    "the other player thinks an honest 'that did not work for me' beats a convincing fake orgasm.",
    "a well-timed orgasm can make a terrible week look suspiciously manageable.",
    "the other player thinks a couple can discuss a threesome and still decide never to have one.",
    "a booty call who only texts after midnight does not get boyfriend privileges at breakfast.",
    "the other player thinks being naked with someone can be easier than telling them what you want.",
    "a sex toy is a better purchase than lingerie you actively hate wearing.",
    "the other player thinks being someone's rebound can be an excellent short-term arrangement.",
    "jealousy over a vibrator is a spectacularly avoidable relationship problem.",
    "the other player thinks a hookup with a friend needs an exit plan before an opening move.",
    "scheduled sex can be hotter than hoping two exhausted people become spontaneous.",
    "the other player thinks you can have a filthy sense of humor and a very vanilla sex life.",
    "your favorite porn does not automatically belong on a real-life to-do list.",
    "the other player thinks a couple's sex-toy drawer is more revealing than their wedding vows.",
    "a person who calls every former partner bad in bed may be the common denominator.",
    "the other player thinks admitting you want better sex is kinder than silently resenting the sex you have."
  ]
};

const adultExpansion = Object.entries(adultPacks).flatMap(([type, prompts]) =>
  prompts.map((prompt, index) => ({
    id: `adult-v3-${type.replace(/ /g, '-')}-${index + 1}`,
    description: `Drink if you think ${prompt}`,
    type,
    explicit: true,
    fresh: true
  }))
);
export default adultExpansion;
